// src/features/system/SystemBanner.tsx
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";

import { systemStatusQuery } from "./api";

const KEY = "adman.announcement.dismissed";

/** شريط أعلى الصفحة: وضع الصيانة (أحمر، لا يُغلق) وإعلان المنصة (يُغلق للجلسة الحالية فقط). */
export function SystemBanner({ adminNote = false }: { adminNote?: boolean }) {
  const { data } = useQuery(systemStatusQuery);
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem(KEY));
  if (!data) return null;
  const showAnnouncement = data.announcement && dismissed !== data.announcement;
  return (
    <>
      {data.maintenance && (
        <div role="alert" data-tone="bad" data-testid="maintenance-banner" className="px-6 py-2.5 text-center text-[13px]" style={{ background: "var(--bg)", borderBottom: "1px solid var(--fg)", color: "var(--fg)" }}>
          <strong>وضع الصيانة</strong> — {data.maintenance_message}{adminNote ? " (أنت أدمن المنصة: الشاشات تعمل لك بشكل طبيعي)" : ""}
        </div>
      )}
      {showAnnouncement && (
        <div role="status" data-tone="info" data-testid="announcement-banner" className="flex items-center justify-center gap-3 px-6 py-2 text-[13px]" style={{ background: "var(--bg)", borderBottom: "1px solid var(--fg)", color: "var(--fg)" }}>
          <span>{data.announcement}</span>
          <button type="button" aria-label="إخفاء الإعلان" className="text-[12px] opacity-70 hover:opacity-100" onClick={() => { sessionStorage.setItem(KEY, data.announcement); setDismissed(data.announcement); }}>إخفاء</button>
        </div>
      )}
    </>
  );
}
